import { createNetworkGroup, updateNetworkGroupName, } from "@Api/CountrySettings/countryGroup";
import Button from "@Components/Button";
import Card from "@Components/Card";
import Close from "@Components/Icons/Close";
import Loading from "@Components/Icons/Loading";
import InfoPopup from "@Components/InfoPopup";
import { ERROR, SUCCESS } from "@Components/Toast";
import { getUnselectedCountries } from "@Helpers/CountryGroup";
import Box from "@mui/material/Box";
import React from "react";
import styles from "./index.module.scss";
export default class Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: props.group?.name || "",
            errors: {},
            includeUnassigned: false,
            isDirtyForm: false,
            isLoading: false,
        };
    }
    componentDidUpdate(previousProps) {
        if (this.props.group?.id !== previousProps.group?.id ||
            (!this.props.open && previousProps.open)) {
            this.setState({
                name: this.props.group?.name || "",
                errors: {},
                includeUnassigned: false,
                isDirtyForm: false,
            });
        }
    }
    update = async () => {
        this.setState({ isLoading: true });
        try {
            const updateData = {
                newName: this.state.name,
                networkId: this.props.networkId,
                groupId: this.props.group.id,
                allNetworks: this.props.allGroups,
            };
            await updateNetworkGroupName(updateData, this.props.isSync);
            this.props.close(true);
            this.props.notify({
                status: SUCCESS,
                title: "Success",
                description: "Country group renamed successfully.",
            });
        }
        catch (error) {
            const errorResponse = error.response;
            if (errorResponse?.status === 405) {
                this.props.notify({
                    status: ERROR,
                    title: "Group name already exists.",
                    description: "Please use a different name.",
                });
                return;
            }
            console.log("error", error);
            this.props.notify({
                status: ERROR,
                title: "Error",
                description: "Failed to rename country group.",
            });
        }
        finally {
            this.setState({ isLoading: false });
        }
    };
    create = async () => {
        this.setState({ isLoading: true });
        try {
            let selectedCountries = [];
            if (this.state.includeUnassigned) {
                selectedCountries = getUnselectedCountries(this.props.countries, this.props.allGroups);
            }
            const data = [
                {
                    name: this.state.name,
                    networkId: this.props.networkId,
                    selectedCountries,
                    type: this.props.countryGroupType,
                },
                ...Object.values(this.props.allGroups),
            ];
            await createNetworkGroup(data, this.props.isSync);
            this.props.close(true);
            this.props.notify({
                status: SUCCESS,
                title: "Success",
                description: "Country group created successfully.",
            });
        }
        catch (error) {
            const errorResponse = error.response;
            if (errorResponse?.status === 405) {
                this.props.notify({
                    status: ERROR,
                    title: "Group name already exists.",
                    description: "Please use a different name.",
                });
                return;
            }
            console.log("error", error);
            this.props.notify({
                status: ERROR,
                title: "Error",
                description: "Failed to create country group.",
            });
        }
        finally {
            this.setState({ isLoading: false });
        }
    };
    onSave = () => {
        if (!this.state.isDirtyForm) {
            return;
        }
        if (this.props.group) {
            return this.update();
        }
        return this.create();
    };
    validateGroupName = (value) => {
        if (value.trim() === "") {
            return "Group name can not be empty.";
        }
        if (value.length > 250) {
            return "Input exceeds 250 character limit.";
        }
        return "";
    };
    change = (name, value) => {
        this.setState((previousState) => ({
            ...previousState,
            errors: {
                name: this.validateGroupName(value),
            },
            [name]: value,
            isDirtyForm: true,
        }));
    };
    createPopup = (close) => {
        return (React.createElement(Card, { className: styles.createPopup },
            React.createElement(Box, { className: styles.header },
                React.createElement("h2", { className: styles.title }, this.props.group?.name
                    ? "Edit group name"
                    : "New group"),
                React.createElement("div", { onClick: () => close(), className: styles.closeBtn },
                    React.createElement(Close, { onClick: () => close(), color: "#585C61", size: "0.75rem", className: styles.exitButton }))),
            React.createElement(Box, { className: styles.content },
                React.createElement("div", { className: styles.inputForm },
                    React.createElement("label", null,
                        "Group Name ",
                        React.createElement("span", null, "*")),
                    React.createElement("input", { key: this.props.group?.id || "new", defaultValue: this.props.group?.name || "", placeholder: "Enter group name", name: "name", type: "text", onChange: (event) => this.change("name", event.target.value) }),
                    this.state.errors.name && (React.createElement("div", { className: styles.error }, this.state.errors.name))),
                this.props.group ? null : (React.createElement("div", null,
                    React.createElement("label", { className: styles.checkbox },
                        React.createElement("input", { type: "checkbox", onChange: () => this.setState((previousState) => ({
                                ...previousState,
                                includeUnassigned: !previousState.includeUnassigned,
                            })), checked: this.state.includeUnassigned }),
                        "Include all unassigned countries")))),
            React.createElement(Box, { className: styles.actions },
                React.createElement(Button, { click: () => close(), dark: true, className: styles.cancelBtn }, "CANCEL"),
                React.createElement(Button, { className: `${this.state.isDirtyForm && !this.state.errors.name
                        ? ""
                        : styles.disabled}`, click: this.onSave, disabled: !this.state.isDirtyForm ||
                        !!this.state.errors.name ||
                        this.state.isLoading }, this.state.isLoading ? (React.createElement(Loading, { size: "1rem" })) : ("SAVE")))));
    };
    render() {
        return (React.createElement(InfoPopup, { trigger: this.props.open, content: this.createPopup, onClose: () => this.props.close() }));
    }
}
